var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"overflow-hidden",attrs:{"id":"clock-exterior","elevation":"6"}},[_c('div',{staticClass:"d-flex align-center justify-center",style:(_vm.clockBackgroundStyle),attrs:{"id":"clock-background"}},[_c('div',{attrs:{"id":"clock-text"}},[_vm._v(_vm._s(_vm.time))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }